import React, {useEffect, useState} from 'react';
import {Avatar, Badge, Box, CircularProgress, IconButton, Sheet, Stack, Typography} from '@mui/joy';
import {SkillModel} from "../model/skill";
import {ProjectRepository} from "../repository/ProjectRepository";
import skillHintIc from '../images/skill_hint.png';

function Skill({skill}: { skill: SkillModel }) {
    const repo = new ProjectRepository();
    const [iconUrl, setIconUrl] = useState<string>(skill.iconUrl);
    useEffect(() => {
        repo.getSkillIconURL(skill).then(value => setIconUrl(value))
    }, [])

    return (
        <Box sx={{borderRadius: 8,}}>
            <Sheet variant='soft' sx={{borderRadius: 8, padding: 1}}>
                <Stack alignItems="center" spacing={1} justifyContent="center" direction="column">
                    <Avatar variant='plain' size={iconUrl ? 'lg' : 'sm'} src={iconUrl ? iconUrl : skillHintIc}/>
                    <Typography sx={{
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                    }} textAlign="center" level="title-sm" fontWeight="lg">{skill.title}
                    </Typography>
                    <Typography color='neutral' level='body-xs' variant="plain">
                        {"" + skill.yearsOfExperiences + (skill.yearsOfExperiences > 1 ? " years" : " year")}
                    </Typography>
                    <Typography variant='soft'
                                maxWidth='48px' sx={{paddingX: 0.5, borderRadius: 8,}}
                                textAlign="center" level="title-md" fontWeight="lg">
                        {skill.level * 100 / 4}%
                    </Typography>
                </Stack>
            </Sheet>
        </Box>
    );
}
export default Skill;